// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"HeroSlider-module--carouselWrapper--a-SzN","arrowBtn":"HeroSlider-module--arrowBtn--2C5NF"};